let ethersModulePromise = null;

/** 按需加载 ethers，避免打进首屏 bundle */
export function loadEthers() {
  if (!ethersModulePromise) {
    ethersModulePromise = import('ethers');
  }
  return ethersModulePromise;
}
